import TextRecord from './TextRecord'
export default TextRecord
